import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi, X } from 'lucide-react';
import { onNetworkChange, isOnline, processOfflineQueue } from '../utils/api';

const OfflineBanner = () => {
  const [online, setOnline] = useState(isOnline());
  const [showReconnected, setShowReconnected] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const unsubscribe = onNetworkChange((status) => {
      setOnline(status);
      if (status) {
        setShowReconnected(true);
        setDismissed(false);
        processOfflineQueue();
        setTimeout(() => setShowReconnected(false), 3000);
      } else {
        setDismissed(false);
      }
    });
    return unsubscribe;
  }, []);

  if (online && !showReconnected) return null;
  if (dismissed && !online) return null;

  if (showReconnected) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-emerald-500 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-medium animate-slideDown" data-testid="online-banner">
        <Wifi className="w-4 h-4" />
        Conexion restaurada
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gray-800 text-white px-4 py-2.5 flex items-center justify-between text-sm" data-testid="offline-banner">
      <div className="flex items-center gap-2 font-medium">
        <WifiOff className="w-4 h-4 text-amber-400" />
        Sin conexion — modo offline
      </div>
      <button onClick={() => setDismissed(true)} className="p-1 hover:bg-white/10 rounded">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default OfflineBanner;
